export function processDate(date){
    var parts = date.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }

export  function parseTimestamp(timestampStr) {
  return new Date(new Date(timestampStr).getTime() + (new Date(timestampStr).getTimezoneOffset() * 60 * 1000));
}
  